import {forwardRef} from 'react'
import Svg, {Path} from 'react-native-svg'

import {type Props, useCommonSVGProps} from '#/components/icons/common'
import {TOKENS} from '#/wsocial/service/design-system/tokens'

/*
 * Brand W mark, traced from the app icon (assets/icon-wsocial.svg, viewBox
 * 0 0 73 73): the two white strokes plus the mint check, without the icon's
 * shading layers and purple tile so it sits on the fallback's neutral tile.
 * Deliberately NOT tintable - it is the brand mark, not a glyph - so `fill` is
 * ignored; only `size`/`width` and `style` apply. Rendered with the nonzero
 * fill rule so the overlapping strokes union instead of punching holes.
 */
const W_LEFT = 'M21.58 17.23H9.28L27.58 60.13L34.2 48.88L21.58 17.23Z'
const W_MID =
  'M30.58,28.15l3.78-5.98c1.46-2.31,4.96-1.85,5.77.77l4.14,13.49,5.58-19.2h11.88l-17.46,43.02-13.68-32.1Z'
const W_CHECK =
  'M34.55,37.34l2.99-4.73c1.47-2.32,4.99-1.85,5.79.77l.93,3.04,7.54-26.05h12.72l-20.26,49.87-9.71-22.91Z'

const STROKE = '#FFFFFF'
const CHECK = TOKENS.dark.custom_accent

export const WMarkIcon = forwardRef<Svg, Omit<Props, 'fill'>>(
  function WMarkIcon(props, ref) {
    const {size, style, ...rest} = useCommonSVGProps(props)
    return (
      <Svg
        fill="none"
        {...rest}
        ref={ref}
        viewBox="0 0 73 73"
        width={size}
        height={size}
        style={[style]}>
        <Path fill={STROKE} d={W_LEFT} />
        <Path fill={STROKE} d={W_MID} />
        <Path fill={CHECK} d={W_CHECK} />
      </Svg>
    )
  },
)
